import "./index.css";

export default function Header() {
    return (
        <h1 className="header">todos</h1>
    )
}